import BookingActionsBox from 'components/ui/BookingActionsBox/BookingActionsBox';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { isValidUrl } from '../utils';

const FindSimilarBoatsCard = ({ url, booking }) => {
  const rudderTrack = useRudderStackTrack();
  const isDefaultCard = url === 'https://www.boatsetter.com';

  const goFindMoreBoats = () => {
    rudderTrack('booking_action_renter', {
      bookingId: booking.id,
      bookingState: booking.state,
      action: `${booking.state}_request_click_find_boats`,
      location: 'conversation_action_box',
      sentTo: url,
    });
    if (isValidUrl(url)) {
      window.location.href = url;
    } else {
      window.location.href = 'https://www.boatsetter.com';
    }
  };

  const body = isDefaultCard
    ? 'Continue browsing and find available boats.'
    : `Browse through suggested boats based on your recent booking attempt.`;
  const buttonText = isDefaultCard ? 'Search Boats' : 'Find Similar Boats';

  let title;
  if (booking.state === 'declined') {
    title = 'Booking request declined';
  }
  if (booking.state === 'expired') {
    title = 'Booking request expired';
  }

  return (
    <BookingActionsBox
      title={title}
      ctaText={buttonText}
      subHeading={body}
      userType="renter"
      onSubmit={goFindMoreBoats}
      showCloseButton={false}
      showSubtitle={false}
    />
  );
};

export default FindSimilarBoatsCard;
